<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ isEdit ? 'Edit Holiday' : 'New Holiday' }}</h4>
    <div aria-label="Close" (click)="onCancel()" class="close pull-right">
      <span aria-hidden="true">&times;</span>
    </div>
  </div>

  <div class="modal-body">
    <!-- Name -->
    <div class="form-group">
      <label>Name</label>
      <input type="text" name="NAME" class="form-control rounded-0"
             [(ngModel)]="holiday.NAME" #NAME="ngModel"
             [ngClass]="{'is-invalid': f.submitted && NAME.invalid }" required [maxlength]="100">
      <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
        <div *ngIf="NAME.errors?.required">Name is required</div>
      </div>
    </div>

    <!-- Type -->
    <div class="form-group">
      <label>Type</label>
      <select name="TYPE" class="form-control rounded-0" [(ngModel)]="holiday.TYPE">
        <option value="ONE_OFF">One-off date (a single date, e.g. a one-time closure)</option>
        <option value="FIXED">Annual on a fixed date (same month/day every year)</option>
        <option value="FLOATING">Annual on a weekday (e.g. 4th Thursday of November)</option>
      </select>
    </div>

    <!-- ONE_OFF -->
    <div class="form-group" *ngIf="holiday.TYPE === 'ONE_OFF'">
      <label>Date</label>
      <input type="date" name="HOLIDAY_DATE" class="form-control rounded-0"
             [(ngModel)]="holiday.HOLIDAY_DATE" #DATE="ngModel"
             [ngClass]="{'is-invalid': f.submitted && DATE.invalid }" required>
      <div *ngIf="f.submitted && DATE.invalid" class="invalid-feedback">
        <div *ngIf="DATE.errors?.required">Date is required</div>
      </div>
    </div>

    <!-- FIXED -->
    <div *ngIf="holiday.TYPE === 'FIXED'">
      <div class="row">
        <div class="form-group col-md-6">
          <label>Month</label>
          <select name="MONTH" class="form-control rounded-0" [(ngModel)]="holiday.MONTH" required>
            <option *ngFor="let m of months" [ngValue]="m.v">{{m.n}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label>Day of month</label>
          <input type="number" name="DAY" min="1" max="31" class="form-control rounded-0"
                 [(ngModel)]="holiday.DAY" required>
        </div>
      </div>
      <div class="checkbox-item">
        <input class="checkbox-custom" type="checkbox" name="OBSERVE_WEEKEND" id="OBSERVE_WEEKEND"
               [(ngModel)]="holiday.OBSERVE_WEEKEND"/>
        <label class="checkbox-custom-label" for="OBSERVE_WEEKEND">
          Observe on the following Monday if it falls on a weekend
        </label>
      </div>
    </div>

    <!-- FLOATING -->
    <div *ngIf="holiday.TYPE === 'FLOATING'">
      <div class="row">
        <div class="form-group col-md-4">
          <label>Week</label>
          <select name="WEEK_OF_MONTH" class="form-control rounded-0" [(ngModel)]="holiday.WEEK_OF_MONTH" required>
            <option *ngFor="let w of weeks" [ngValue]="w.v">{{w.n}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>Weekday</label>
          <select name="DAY_OF_WEEK" class="form-control rounded-0" [(ngModel)]="holiday.DAY_OF_WEEK" required>
            <option *ngFor="let d of weekdays" [ngValue]="d.v">{{d.n}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>of Month</label>
          <select name="FMONTH" class="form-control rounded-0" [(ngModel)]="holiday.MONTH" required>
            <option *ngFor="let m of months" [ngValue]="m.v">{{m.n}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label>Offset days (optional)</label>
        <input type="number" name="OFFSET_DAYS" min="0" max="7" class="form-control rounded-0"
               [(ngModel)]="holiday.OFFSET_DAYS">
        <small class="text-muted">e.g. set to 1 for "the day after" (Day after Thanksgiving = 4th Thursday of November + 1).</small>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="footer-wrapper">
      <div class="checkbox-item">
        <input class="checkbox-custom" type="checkbox" name="ENABLED" id="ENABLED" [(ngModel)]="holiday.ENABLED"/>
        <label class="checkbox-custom-label" for="ENABLED">Active</label>
      </div>
      <div class="actions">
        <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
        <button type="submit" class="btn btn-rbv" [disabled]="!f.form.valid || saving">Submit</button>
      </div>
    </div>
  </div>
</form>
